module.exports = __webpack_public_path__ + "static/img/content_bg_id.02b6c7b9.webp";